/* @flow */

const isDinheiro = (nome: string) => /DINHEIRO/i.test(nome);

export default isDinheiro;
